import { ReactNode } from 'react';
import { FiInfo } from 'react-icons/fi';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';

const HeaderWrapper = styled.div`
  padding: 16px 24px;
  background: white;
  border-bottom: 1px solid #ccc;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  word-break: break-word;
`;

interface Props {
  children: ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tooltip?: any;
}

const ToolTipWrapper = styled.div`
  min-width: 350px;
  max-width: 500px;
`;

export const Header = (props: Props) => {
  const { children, tooltip } = props;
  const id = Math.random().toString();
  return (
    <HeaderWrapper>
      <div style={{ textTransform: 'uppercase' }}>{children}</div>
      {tooltip && (
        <div>
          <FiInfo size={'1.0625rem'} data-tip data-for={id} />
          <ReactTooltip
            id={id}
            multiline
            effect="solid"
            getContent={() => <ToolTipWrapper>{tooltip}</ToolTipWrapper>}
            overridePosition={({ left, top }, _currentEvent, _currentTarget, node) => {
              const d = document.documentElement;
              // @ts-expect-error I dont want to fix this
              left = Math.min(d.clientWidth - node?.clientWidth, left);
              // @ts-expect-error I dont want to fix this
              top = Math.min(d.clientHeight - node?.clientHeight, top);
              left = Math.max(0, left);
              top = Math.max(0, top);
              return { top, left };
            }}
          />
        </div>
      )}
    </HeaderWrapper>
  );
};
